import { FeatureFlag, useFeatureFlag } from './useFeatureFlag';

export const useE2E = () => {
  return useFeatureFlag(FeatureFlag.E2E);
};
